import React from "react";
import { Box, Container } from "@mui/material";
import CouncilHierarchyExplorer from "../../components/councils/CouncilHierarchyExplorer";

export default function CouncilDirectoryPage() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f8fafc", py: 2 }}>
      <Container maxWidth="xl" disableGutters sx={{ px: { xs: 1, sm: 2 } }}>
        <CouncilHierarchyExplorer />
      </Container>
    </Box>
  );
}
